"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
  _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
  _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
  _react = _interopRequireDefault(require("react")),
  _reactDatepicker = _interopRequireDefault(require("react-datepicker")),
  Locales = _interopRequireWildcard(require("date-fns/locale")),
  _ValidationMessage = _interopRequireDefault(require("../../FormElements/ValidationMessage")),
  _excluded = ["field", "value", "validationMessage", "touched", "setTouched", "updateForm", "error", "unsetError", "setFocusClass", "setDate", "startDate", "styledComponents", "locale"];
function _getRequireWildcardCache(a) {
  if ("function" != typeof WeakMap) return null;
  var b = new WeakMap(),
    c = new WeakMap();
  return (_getRequireWildcardCache = function (a) {
    return a ? c : b;
  })(a);
}
function _interopRequireWildcard(b, c) {
  if (!c && b && b.__esModule) return b;
  if (null === b || "object" != _typeof(b) && "function" != typeof b) return {
    default: b
  };
  var d = _getRequireWildcardCache(c);
  if (d && d.has(b)) return d.get(b);
  var e = {
      __proto__: null
    },
    f = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var a in b) if ("default" != a && Object.prototype.hasOwnProperty.call(b, a)) {
    var g = f ? Object.getOwnPropertyDescriptor(b, a) : null;
    g && (g.get || g.set) ? Object.defineProperty(e, a, g) : e[a] = b[a];
  }
  return e["default"] = b, d && d.set(b, e), e;
}
function getDateFnsLocale(a) {
  var b,
    c = null === a || void 0 === a ? void 0 : a.substring(0, 2),
    d = null === a || void 0 === a ? void 0 : a.replace("-", "");
  return null !== (b = Locales[c] || Locales[d]) && void 0 !== b ? b : Locales.enUS;
}
var _default = exports["default"] = function (a) {
  var b = a.format,
    c = a.defaultProps,
    d = c.field,
    e = c.value,
    f = c.validationMessage,
    g = c.touched,
    h = c.setTouched,
    i = c.updateForm,
    j = c.error,
    k = c.unsetError,
    l = c.setFocusClass,
    m = c.setDate,
    n = c.startDate,
    o = c.styledComponents,
    p = c.locale,
    q = (0, _objectWithoutProperties2["default"])(c, _excluded),
    r = d.id,
    s = d.isRequired,
    t = d.formId,
    u = d.placeholder,
    v = d.cssClass,
    w = d.datepickerOptions,
    x = d.dateType,
    y = (o || !1).DatePicker,
    z = void 0 === y ? "div" : y,
    A = function adjustDatePickerOptions(a) {
      if (x && "datepicker" === x && a) {
        var b = Object.keys(a);
        if (b && 0 < b.length) for (var c = 0; c < b.length; c++) ("minDate" === b[c] || "maxDate" === b[c]) && (a[b[c]] = new Date(a[b[c]]));
      }
      return a;
    }(w) || {};
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(z, {
    className: "ginput_container ginput_container_date"
  }, _react["default"].createElement(_reactDatepicker["default"], (0, _extends2["default"])({
    name: "input_".concat(r),
    id: "input_".concat(t, "_").concat(r),
    type: "text",
    className: "datepicker hasDatepicker",
    selected: n,
    onChange: function onChange(a) {
      m(a), i({
        target: {
          value: a
        }
      }, d), h(r), k(r), l(a);
    },
    onBlur: function onBlur() {
      i({
        target: {
          value: n
        }
      }, d), h(r), k(r), l(n);
    },
    dateFormat: b || void 0,
    onFocus: function onFocus() {
      return l(!0);
    },
    autoComplete: "off",
    required: s,
    placeholderText: u,
    maxDate: v.includes("past") && new Date(),
    locale: getDateFnsLocale(p)
  }, A))), (f && g || j) && _react["default"].createElement(_ValidationMessage["default"], {
    validationMessage: f,
    error: j,
    id: r
  }));
};